import * as React from 'react';
import AppDocumentTitle from '../AppDocumentTitle/AppDocumentTitle';
import AppFooterUpdater from '../AppFooterUpdater';
import AppTitleUpdater from '../AppTitleUpdater';

/*
  This component is a simplification of AppDocumentTitle, AppFooterUpdater, and AppTitleUpdater. Instead of
  importing and defining all three, this lets you do it all in one place. Hallelujah!
*/

interface AppLayoutContextUpdaterProps {
  appDocumentTitle: string;
  appTitle: string;
  footerConfig: FooterConfig | null;
}

export default class AppLayoutContextUpdater extends React.Component<AppLayoutContextUpdaterProps, {}> {
  render() {
    const { appDocumentTitle, footerConfig, appTitle, children } = this.props;
    return (
      <div className="AppContextUpdater">
        <AppDocumentTitle title={appDocumentTitle}>
          <AppFooterUpdater footerConfig={footerConfig}>
            <AppTitleUpdater text={appTitle}>{children}</AppTitleUpdater>
          </AppFooterUpdater>
        </AppDocumentTitle>
      </div>
    );
  }
}
